import React from "react";
import Text from "../atoms/Text";
import dashboardIcon from "../../assets/Dashboard.png";
import orderHistoryIcon from "../../assets/Order History.png";
import wishlistIcon from "../../assets/Wishlist.png";
import shoppingCartIcon from "../../assets/Shopping Cart.png";
import settingsIcon from "../../assets/Settings.png";
import logoutIcon from "../../assets/Log Out.png";

const iconMap = {
  "dashboard.png": dashboardIcon,
  "orderhistory.png": orderHistoryIcon,
  "wishlist.png": wishlistIcon,
  "shoppingcart.png": shoppingCartIcon,
  "settings.png": settingsIcon,
  "logout.png": logoutIcon,
};

export default function SidebarProfile({
  navigationItems,
  activeSection,
  onNavigate,
}) {
  return (
    <div
      className="sidebar-profile"
      style={{
        border: "1px solid var(--gray1)",
        borderRadius: "8px",
        backgroundColor: "var(--white)",
        overflow: "hidden",
      }}
    >
      <div style={{ padding: "24px 24px 16px" }}>
        <Text
          size="px20"
          weight="w500"
          color="gray9"
          extraStyles={{ display: "block", textAlign: "start" }}
        >
          Navigation
        </Text>
      </div>
      <div style={{ display: "flex", flexDirection: "column" }}>
        {navigationItems.map((item) => {
          const isActive =
            item.key === activeSection ||
            (item.key === "orders" && activeSection === "order-details");

          return (
            <button
              key={item.key}
              type="button"
              onClick={() => onNavigate(item.key)}
              style={{
                border: "none",
                backgroundColor: isActive ? "#edf2ee" : "var(--white)",
                borderLeft: isActive
                  ? "4px solid var(--primary)"
                  : "4px solid transparent",
                padding: "16px 20px",
                display: "flex",
                alignItems: "center",
                gap: "12px",
                cursor: "pointer",
                textAlign: "start",
              }}
            >
              <span
                style={{
                  width: "18px",
                  height: "18px",
                  backgroundImage: `url(${iconMap[item.icon] || item.icon})`,
                  backgroundSize: "contain",
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                  opacity: isActive ? 1 : 0.35,
                  flexShrink: 0,
                }}
              />
              <Text
                size="px16"
                weight="w400"
                color={isActive ? "gray9" : "gray5"}
              >
                {item.label}
              </Text>
            </button>
          );
        })}
      </div>
    </div>
  );
}
